import * as React from "react";
import { useId } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgItalic = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 640 640",
		fill: "currentColor",
		...props,
		children: /* @__PURE__ */ _jsx("path", { d: "M256 120C256 106.7 266.7 96 280 96L488 96C501.3 96 512 106.7 512 120C512 133.3 501.3 144 488 144L411.6 144L279.6 496L360 496C373.3 496 384 506.7 384 520C384 533.3 373.3 544 360 544L152 544C138.7 544 128 533.3 128 520C128 506.7 138.7 496 152 496L228.4 496L360.4 144L280 144C266.7 144 256 133.3 256 120z" })
	});
};
export default SvgItalic;
